import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { applyScoreGoal, getAICoachGoals, getGoalProgress, getNextSteps } from 'thunks';

const useApplyScoreGoal = (applicationId?: string, borrowerId?: string) => {
  const dispatch = useDispatch();
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const hasRequested = useRef(false);

  useEffect(() => {
    if (!applicationId || hasRequested.current) return;

    hasRequested.current = true;

    const runApplyScoreGoal = async () => {
      try {
        const { applied } = await dispatchWithUnwrap(applyScoreGoal(applicationId));

        if (!applied) return;

        dispatch(getAICoachGoals(applicationId));

        if (borrowerId) {
          dispatch(getGoalProgress(borrowerId));
          dispatch(getNextSteps(borrowerId));
        }
      } catch {
        // Non-blocking: dashboard still loads if the endpoint fails.
      }
    };

    runApplyScoreGoal();
  }, [applicationId, borrowerId, dispatch, dispatchWithUnwrap]);
};

export default useApplyScoreGoal;
